import { Button, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import SuccessIcon from '../Icons/SuccessIcon';
import YellowDangerIcon from '../Icons/YellowDangerIcon';
import Loader from '../Loader';
import { sleep } from '../../utils/sleep';

interface Props {
  isOpen: boolean;
  toggleModal(isOpen: boolean): void;
  onActivate(): void;
  onClose(): void;
  isBeneficiaryActive: boolean | undefined;
  showSuccessModal: boolean;
  isLoading: boolean;
}

const ModalActivate: FC<Props> = ({
  isOpen = false,
  toggleModal,
  onActivate,
  onClose,
  isBeneficiaryActive,
  showSuccessModal,
  isLoading,
}) => {
  const { t } = useTranslation(['reactivateBeneficiary']);

  const refresh = async () => {
    await sleep(10000);
    window.postMessage({ type: 'REFRESH', refresh: true }, '*');
  };

  return (
    <VbzModal
      id="modal-deactive-beneficiarie"
      isOpen={isOpen}
      backButton={!isMobile}
      closedButton={isMobile}
      type="right"
      toggle={() => {
        toggleModal(false);
      }}
    >
      {!showSuccessModal ? (
        <div data-testid="test-reactivate" className="reactivate-modal">
          <span className="title">{isBeneficiaryActive ? t('deactivate_beneficiary') : t('activate_beneficiary')}</span>
          <div className="attention-box">
            <div className="icon-attention">
              <YellowDangerIcon />
              <span>Atenção!</span>
            </div>
            <span className="text">
              {isBeneficiaryActive
                ? 'Ao confirmar essa ação, o perfil vai perder o acesso a todos os benefícios deste portal.'
                : 'Ao confirmar essa ação, o perfil vai ter acesso a todos os benefícios. Para associar esse perfil aos benefícios, acesse a área de cadastro. '}
            </span>
          </div>
          <Button onClick={() => onActivate()} disabled={isLoading}>
            {isLoading ? <Loader small /> : 'Confirmar'}
          </Button>
          <span data-testid="test-cancel-button" className="cancel-reactivate" onClick={() => toggleModal(false)}>
            Cancelar
          </span>
        </div>
      ) : (
        <div className="success-wrapper">
          <div className="icon-wrapper">
            <SuccessIcon />
          </div>
          <p>{isBeneficiaryActive ? t('success_deactivate') : t('success_reactivate')}</p>
          <button
            data-testid="test-ok-button"
            type="button"
            className="ok-button"
            onClick={() => {
              toggleModal(false);
              onClose();
              refresh();
            }}
          >
            Entendi
          </button>
        </div>
      )}
    </VbzModal>
  );
};

export default ModalActivate;
